"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autocomplete = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.autocomplete = (0, basic_1.applyBase)({
    mobileModal: {},
    tagBlock: Object.assign(Object.assign({ flexDirection: 'column', flex: '1 auto', marginY: ['15px', 0], maxHeight: ['100%', '50vh'], overflowY: ['none', 'auto'], px: [null, 3], pt: [null, '14px'], width: [null, '100%'], backgroundColor: [null, 'background'] }, font_faces_1.FONT_SIZE.LARGE), { boxShadow: [null, '0 3px 5px 1px rgba(0,0,0,0.06)'], border: ['none', '1px solid'], borderColor: [null, 'borderInput'], borderTop: ['none', 'none'] }),
    inputWrapStyles: {
        border: '1px solid',
        borderColor: 'borderColor',
        backgroundColor: 'bgInput',
        flexWrap: 'wrap',
        alignItems: 'center',
        p: [1, 0],
        input: {
            width: '100%',
            border: 'none',
            [basic_1.basic.media.tablet]: {
                height: '58px',
            },
        },
    },
    suggestionListStyles: {
        borderBottom: '1px solid ',
        borderColor: 'lightGreyFourth',
        '.autocomplete-option > .-icon': {
            mr: '14px',
        },
        pb: 2,
    },
    tagWrap: {
        display: 'inline-flex',
        alignItems: 'center',
        py: 1,
        px: 2,
        border: '1px solid',
        borderColor: 'borderInput',
        borderRadius: 'default',
        backgroundColor: 'background',
        m: 1,
        mr: 0,
        color: 'secondary',
    },
    autocompleteRemoveButtonStyles: {
        ml: 1,
        color: 'darkGray',
    },
});
//# sourceMappingURL=autocomplete.js.map